import * as React from "react";
function SvgCorners(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={6}
        d="M3 14V3h11m20 0h11v11m0 20v11H34m-20 0H3V34"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCorners);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
